class ProductNotifyModal extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.submitInput = this.querySelector('input[type="submit"]');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    const email = this.form.querySelector('input[type="email"]').value;
    const variant_id = this.form.getAttribute('data-bis-variant-id');
    let company_id;
    if (window.location.href.includes('uk')) {
      company_id = 'VnBRVb';
    } else {
      company_id = 'YrrctJ';
    }
    console.log(company_id, 'company_id');

    const config = {
      method: 'POST',
      headers: {
        accept: 'application/json',
        revision: '2024-07-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: `${email}`
                }
              }
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variant_id}`
              }
            }
          }
        }
      })
    };

    console.log(config, 'config');

    this.sendRequest(company_id, config)
  }

  async sendRequest(company_id, config) {
    try {
      const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${company_id}`, config);
      if (response.status === 202) {
        this.submitInput.classList.add('hide');
        const successMessage = document.createElement('p');
        successMessage.textContent = "You're in! We'll let you know when it's back.";
        this.form.appendChild(successMessage);
      }
    } catch (error) {
      console.error(error);
    }
  }
}
customElements.define('product-notify-modal', ProductNotifyModal);